import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { AccountService } from './../../services/services.module';
import { GlobalValidators } from './../../utils/validators';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss'],
})
export class AdminLoginComponent implements OnInit {
  signinForm: FormGroup;
  registrationForm: FormGroup;
  signinFormErrors: any;
  startRegistraionShowNIC = false;
  showSignupForm = false;
  signUpFormErrors = false;
  changePWType = false;
  showRecaptcha = false;
  siteKey = environment.siteKey;
  siginingInProgress;
  requestCaptchaKey: any;
  automationEnvirement: any;
  resetOnError = false;
  suggestedId: any;
  profileId: any;
  eventId: any;
  constructor(private fb: FormBuilder, private router: Router, private accountservice: AccountService) {
    this.accountservice.getSavedId.subscribe(async (savedId) => {
      // console.log(savedId, 1);
      if (savedId) {
        this.suggestedId = Object.keys(savedId).includes('activities') ? savedId['activities']['id'] : null;
        this.profileId = Object.keys(savedId).includes('profile') ? savedId['profile'] : null;
        this.eventId = Object.keys(savedId).includes('eventId') ? savedId['eventId']['eventId'] : null;
      }
    });
  }

  ngOnInit() {
    localStorage.clear();
    this.bindSigninForm();
    this.accountservice.signOut();
  }
  bindSigninForm() {
    let testUsername, testPassword;
    if (environment.dev) {
      testUsername = 'digital@cal.lk';
      testPassword = 'Test@123';
      this.showRecaptcha = true;
    }
    this.signinForm = this.fb.group({
      username: [testUsername, [Validators.required, GlobalValidators.email]],
      password: [testPassword, Validators.required],
      captchaResponse: [],
      captchaText: [, Validators.required],
    });
    this.signinForm.get('password').valueChanges.subscribe((value) => {
      this.showRecaptcha = true;
    });
  }
  BackToSignupProcess() {
    this.startRegistraionShowNIC = false;
    this.signUpFormErrors = false;
  }

  resolved(captchaResponse: string) {
    this.signinForm.get('captchaResponse').setValue(captchaResponse);
  }
  onSignin(form) {
    if (form.invalid) {
      return;
    }
    this.resetOnError = false;
    this.siginingInProgress = true;
    this.signinForm.get('captchaResponse').setValue(this.requestCaptchaKey + ',' + this.signinForm.get('captchaText').value.toLowerCase());
    this.accountservice
      .signIn(form.value)
      .then((data) => {
        this.siginingInProgress = false;
        if (this.suggestedId) {
          this.router.navigate([`/crm/activities`], { queryParams: { id: `${this.suggestedId}` } });
        } else if (this.eventId && this.profileId) {
          this.router.navigate([`/crm/profile/${this.profileId}`], { queryParams: { eventId: `${this.eventId}` } });
        } else {
          this.router.navigate(['/']);
        }
      })
      .catch((e) => {
        this.resetOnError = true;
        this.siginingInProgress = false;
        const userName = this.signinForm.get('username').value;
        const password = this.signinForm.get('password').value;
        form.resetForm();
        this.signinForm.get('username').setValue(userName);
        this.signinForm.get('password').setValue(password);
        if (e.status >= 400 && e.status < 500) {
          if (!!e.json() && !!e.json().message && e.json().message.indexOf('CAPTCHA') >= 0) {
            this.signinFormErrors = 'The CAPTCHA wasn&rsquo;t entered correctly. Try it again';
          } else if (!!e.json() && !!e.json().error_description && e.json().error_description.indexOf('locked') >= 0) {
            this.signinFormErrors = e.json().error_description;
          } else {
            this.signinFormErrors = 'Invalid Email or Password';
          }
        }
      });
  }
  captchaRequest(event) {
    this.requestCaptchaKey = event.key;
    this.automationEnvirement = event.required;
  }
  displayPassword() {
    this.changePWType = !this.changePWType;
  }
}
